module.exports = __webpack_public_path__ + "assets/img/2209.ddb163b3.png";